import React from 'react';

export const WorkflowDispatchContext = React.createContext(null);
export const WorkflowStateContext = React.createContext(null);
